import React, { useEffect, useRef, useState } from "react";
import CopyTableButton from "./CopyTableButton";
import DownloadTableButton from "./DownloadTableButton";
import { buildCsvData, getTableName, type TableActions } from "../tableUtils";

interface MarkdownTableProps extends React.HTMLAttributes<HTMLTableElement> {
  tableActions?: TableActions;
}

const MarkdownTable: React.FC<MarkdownTableProps> = ({
  className,
  children,
  tableActions,
  ...rest
}) => {
  const tableRef = useRef<HTMLTableElement>(null);
  const [csvData, setCsvData] = useState<string[][]>([[]]);
  const [filename, setFilename] = useState("Seemplicity_data_table.csv");

  useEffect(() => {
    if (!tableActions?.allowActions || !tableRef.current) {
      return;
    }
    const tableEl = tableRef.current;
    setCsvData(buildCsvData(tableEl));
    const prefix = tableActions.csvNamePrefix || "Seemplicity_data_table";
    const domName = getTableName(tableEl) || "";
    setFilename(`${prefix}_${domName}_${Date.now()}.csv`);
  }, [
    tableActions?.allowActions,
    tableActions?.csvNamePrefix,
    setCsvData,
    setFilename,
  ]);

  return (
    <div className={`markdown-table-outer ${className}`}>
      <div className={`markdown-table-wrap ${className}`}>
        <table ref={tableRef} className={className} {...rest}>
          {children}
        </table>
      </div>
      {tableActions?.allowActions && (
        <div className="table-action-buttons">
          <CopyTableButton tableRef={tableRef} />
          <DownloadTableButton csvData={csvData} filename={filename} />
        </div>
      )}
    </div>
  );
};

export default MarkdownTable;
